import { OverlayRef } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * a reference to the dialog itself. can be injected into the component added to the
 * overlay and then used to close itself.
 */
@Injectable({
  providedIn: 'root'
})
export class OverlayAccessor {
  /** an observable that emits when the overlay's backdrop is clicked */
  get backdropClick$() {
    return this.overlayRef.backdropClick();
  }

  /** an observable that emits when the overlay has closed */
  get onDismiss$(): Observable<any> {
    return this._dismissEmitter.asObservable();
  }

  private _dismissEmitter = new Subject<any>();

  constructor(private overlayRef: OverlayRef) {}

  /**
   * @description
   * closes the overlay. we can optionally provide a result.
   */
  public dismiss(result?: any) {
    this.overlayRef.dispose();
    this._dismissEmitter.next(result);
    this._dismissEmitter.complete();
  }
}
